import { create } from 'zustand';

const useNotificationStore = create((set) => ({
  notifications: [],
  addNotifications: (newNotifications) => set((state) => ({ ...state, notifications: newNotifications })),
}));

export default useNotificationStore;

